import Utils from '@/util'
import slideOptionAPI from '@/api/slideOption'

const getters = {
  getActiveSlideOptionTitle: () => (slideOption) => {
    const hasTitle = slideOption && slideOption.title && slideOption.title.length > 0
    if (!hasTitle) return null
    return slideOption.title
  },
}

const actions = {
  async addOptionAction({ commit, rootState }, option) {
    const { SlideOptions } = rootState.slideActive
    let newOption = {
      index: SlideOptions.length + 1,
      randomIndexId: Utils.generateRandomString(),
      slideId: rootState.slideActive.id,
      presentationId: rootState.presentation.id,
    }
    // if have payload,call api to create new option
    if (option) {
      const payload = { ...newOption, ...option }

      const res = await slideOptionAPI.createSlideOption(payload)
      newOption = { ...res, ...option }
    }
    // push to top
    SlideOptions.unshift(newOption)
    commit('updateSlideActive', { SlideOptions }, { root: true })
    return newOption
  },
  deleteOptionAction({ commit, rootState }, slideOption) {
    const { SlideOptions } = rootState.slideActive
    if (slideOption.id) {
      slideOptionAPI.deleteSlideOption(slideOption.id, {
        slideId: rootState.slideActive.id,
        presentationId: rootState.presentation.id,
      })
    }

    const newSlideOptions = SlideOptions.filter((option) => option.id !==
        slideOption.id || option.randomIndexId
        !== slideOption.randomIndexId)
    commit('updateSlideActive', { SlideOptions: newSlideOptions }, { root: true })
  },
  setCorrectOptionAction({ commit, rootState }, id) {
    const { SlideOptions } = rootState.slideActive
    if (!id) return
    const payload = {
      slideId: rootState.slideActive.id,
      correct: true,
      presentationId: rootState.presentation.id,
    }
    slideOptionAPI.updateSlideOption(id, payload)
    SlideOptions.map((option) => {
      if (option.id === id) {
        option.correct = true
      }
      return option
    })
    commit('updateSlideActive', { SlideOptions }, { root: true })
  },
}

const slideOptions = {
  namespaced: true,
  getters,
  actions,
}

export default slideOptions
